import { darken } from '@theme-ui/color'
import type { Theme } from '@theme-ui/core'

const silversneakersTheme: Theme = {
  colors: {
    primary: '#0058ac',
    secondary: '#0076ca',
    tertiary: '#e2cda8',
    blue: '#2a5dde',
    darkGrey: '#4a4a68',
    grey: '#757582',
    grey10: '#f6f8fa',
    primary20: '#e0e9ff',
    primary70: '#b2c8ff',
    secondary20: '#feddd1',
    secondary70: '#ff7845',
    tertiary20: '#f9f5ef',
    white: 'white',
  },
  buttons: {
    primary: {
      backgroundColor: 'primary',
      borderRadius: '4px',
      textTransform: 'uppercase',
      fontWeight: 700,
      transition: `background 200ms ease-out`,

      ':disabled': {
        backgroundColor: 'primary20',
      },
      ':hover': {
        backgroundColor: darken('primary', 0.1),
      },
    },
    primaryOutline: {
      backgroundColor: 'transparent',
      border: '2px solid',
      borderColor: 'primary',
      color: 'primary',
      textTransform: 'uppercase',
      fontWeight: 700,
      fontSize: '16px',
      transition: `background 200ms ease-out`,
    },
    secondary: {
      backgroundColor: 'white',
      borderRadius: '4px',
      color: 'primary',
      fontWeight: 700,
      fontSize: '16px',
      transition: `background 200ms ease-out`,
      ':disabled': {
        backgroundColor: 'secondary70',
      },
      ':hover': {
        backgroundColor: darken('white', 0.1),
      },
    },
    tertiary: {
      border: '2px solid',
      borderRadius: '4px',
      borderColor: 'secondary',
      fontWeight: 700,
      fontSize: '16px',
      transition: `background 200ms ease-out, color 200ms ease-out`,
      ':disabled': {
        backgroundColor: 'secondary70',
      },
      ':hover': {
        backgroundColor: 'primary',
        color: 'white',
      },
    },
    greyOutline: {
      backgroundColor: 'white',
      borderRadius: '4px',
      color: 'primary',
      transition: `background 200ms ease-out`,
      opacity: '0.3',
      ':hover': {
        backgroundColor: darken('white', 0.1),
      },
    },
    clearMuted: {
      backgroundColor: 'transparent',
      color: 'primary',
      textTransform: 'uppercase',
      ':disabled': {
        backgroundColor: 'secondary70',
      },
      ':hover': {
        backgroundColor: darken('primary', 0.1),
      },
    },
    slideToggle: {
      backgroundColor: 'primary',
      borderRadius: '4px 0 0 4px',
      ':hover': {
        backgroundColor: darken('primary', 0.1),
      },
    },
    chatInput: {
      close: {
        color: 'white',
        background: 'primary',
      },
      smiley: {
        color: 'white',
        background: 'primary',
        borderRadius: '4px',
      },
      send: {
        color: 'white',
        background: 'primary',
      },
    },
  },
  text: {
    primary: {
      color: 'primary',
    },
  },
  styles: {
    chat: {
      input: {
        borderRadius: '4px',
      },
      message: {
        header: {
          background: 'primary',
        },
        self: {
          background: 'blue',
        },
        other: {
          background: 'grey10',
        },
        welcome: {
          background: '#f4f4f7',
        },
      },
    },
    dialog: { container: { borderRadius: 0 } },
    message: {
      container: {
        background: 'white',
        borderRadius: 0,
      },
      title: {
        color: '#333333',
      },
      status: {
        finished: {
          color: 'primary',
        },
        private: {
          color: 'primary',
        },
        startingSoon: {
          color: 'primary',
        },
      },
    },
    overlay: {
      backContainer: {
        // Default styles work here.
      },
      title: {
        borderRadius: '0px 4px 4px 0px',
        gap: '0',
      },
      backButton: {
        borderRadius: '4px 0px 0px 4px',
        gap: '0',
      },
    },
    sidebar: {
      header: {
        root: {
          backgroundColor: 'secondary',
        },
        counter: {
          backgroundColor: 'primary',
        },
        settings: {
          color: 'primary',
        },
        participants: {
          'img:first-child': {
            color: 'primary',
          },
          live: {
            color: 'grey10',
            backgroundColor: 'primary',
          },
        },
      },
      tabs: {
        container: {
          background: 'secondary',
        },
        item: {
          "&[data-active='true']": {
            backgroundColor: 'white',
            color: 'primary',
          },
          "&[data-active='false']": {
            backgroundColor: 'secondary',
            color: 'white',
          },
        },
      },
      toggle: {
        borderRadius: 'unset',
      },
    },
    ratings: {
      active: {
        backgroundColor: 'primary',
        color: 'white',
      },
      passive: {
        backgroundColor: 'white',
        border: '3px solid',
        borderColor: 'primary',
        color: 'primary',
      },
    },
  },
}

export default silversneakersTheme
